module.exports = __webpack_public_path__ + "img/chart-horizontal.9c801edb.svg";